import axios from 'axios'
import {MessageBox, Message} from 'element-ui'
import store from "@/store";
import router from "@/router";

const service = axios.create({
    baseURL: '/api', // url = base url + request url
    timeout: 30000 // request timeout (30秒，用于阅读/听力评分等耗时操作)
})

// 登录失效弹框单例标志：页面并发多个请求同时返回-100时，只弹一次
let reloginDialogShowing = false

// request interceptor
service.interceptors.request.use(
    config => {
        return config
    },
    error => {

        // do something with request error
        return Promise.reject(error).catch(err => {
                this.$message.error(err.message);
                console.log(err);
            }
        )
    }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        // console.log('service.interceptors.response.use',res)
        // if the custom code is not 20000, it is judged as an error.

        if (res.code !== 1) {
            if (res.code === -100) {
                if (!reloginDialogShowing && router.currentRoute.path !== '/') {
                    reloginDialogShowing = true
                    MessageBox.confirm('登陆失效，请选择重新登录', '登录失效确认', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        store.commit('REMOVE_STORAGE',store.state.token);
                        // 硬跳转而非router.push：路由级重渲染会打断弹框关闭动画留下僵尸弹框，整页刷新彻底重置
                        window.location.href = '/';
                    }).catch(() => {
                        // 用户点“取消”：吞掉reject，避免控制台 Uncaught (in promise)
                    }).finally(() => {
                        reloginDialogShowing = false
                    })
                }
            }else{
                Message({
                    message: res.msg || 'Error',
                    type: 'error',
                    duration: 2 * 1000
                })

            }

            return Promise.reject(res.msg)
        } else {
            return Promise.resolve(res)
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
